// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Usage } from "./usage";

export class NormalUsage implements flatbuffers.IUnpackableObject<NormalUsageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalUsage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalUsage(bb: flatbuffers.ByteBuffer, obj?: NormalUsage): NormalUsage {
    return (obj || new NormalUsage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNormalUsage(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalUsage,
  ): NormalUsage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalUsage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  message(): Usage {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Usage.Up;
  }

  static startNormalUsage(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: Usage) {
    builder.addFieldInt16(0, message, Usage.Up);
  }

  static endNormalUsage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalUsage(builder: flatbuffers.Builder, message: Usage): flatbuffers.Offset {
    NormalUsage.startNormalUsage(builder);
    NormalUsage.addMessage(builder, message);
    return NormalUsage.endNormalUsage(builder);
  }

  unpack(): NormalUsageT {
    return new NormalUsageT(this.message());
  }

  unpackTo(_o: NormalUsageT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalUsageT {
    const t = new NormalUsageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalUsageT implements flatbuffers.IGeneratedObject {
  constructor(public message: Usage = Usage.Up) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalUsage.createNormalUsage(builder, this.message);
  }

  clone(): NormalUsageT {
    const obj = new NormalUsageT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalUsageT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalUsage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
